;(function () {

"use strict";

var validateEmail = function (email) {
  if (!email) { return false; }

  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

var PageView = Backbone.View.extend({
  initialize: function () {
    var self = this;
    var $form = this.$el.find('.advisor-form form');
    this.$form = $form;

    $form.on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var invalid = false;

      $form.find('input, textarea, select').each(function (el) {

        if ($(this).attr('type') === 'email') {

          if (!validateEmail($(this).val())) {
            $(this).addClass('error');
            invalid = true;
          } else {
            $(this).removeClass('error');
          }

        } else if (!$(this).val() && !$(this).hasClass('optional')) {
          $(this).addClass('error');
          invalid = true;
        } else {
          $(this).removeClass('error');
        }
      });

      if (!invalid) {
        self.submitForm();
      }

      return false;
    });
  },

  submitForm: function () {
    this.$form.find('button[type="submit"]').addClass('success');

    var self = this;
    var url = "//dev.roseandrex.com/contact-us";

    $.post(url, self.$form.serialize(), function (d) {
      if (d && d.status === 'success') {
        self.$form.find('.group').toggleClass('hidden');
        self.$form.find('h3 > span').css({opacity: 0});
        var pt = self.$el.find('.advisor-form').position().top - 100;
        $('html, body').animate({scrollTop: pt}, '1000');
      } else {
        alert('Something went wrong, please try again');
        self.$form.find('button[type="submit"]').removeClass('success');
      }
    }, "json");
  }
});

module.exports = PageView;

}());